<template>
  <div class="d-none">
    <p>Socket Connected: {{ isConnected }} ({{ socketId }})</p>
    <button @click="pingServer()">Ping Server</button>
    <button @click="pingServer()">Disconnect</button>
  </div>
</template>

<script>
/* eslint-disable */
import io from "socket.io-client";
import { mapState, mapGetters } from "vuex";
import msgpackParser from "socket.io-msgpack-parser";
import SocketHolder from "../SocketHolder";
import { EventBus } from "../events/eventBus";
import { recognitionLanguages } from "../constants";

export default {
  name: "CallerListener",
  props: {
    roomId: String,
    accessToken: String,
    conversationId: String,
  },
  data() {
    return {
      socket: null,
      socketId: null,
      isConnected: false,
    };
  },
  computed: {
    ...mapState({
      serverUrl: (state) => state.connection.serverUrl,
      wsOnly: (state) => state.connection.wsOnly,
      path: (state) => state.connection.path,
      namespace: (state) => state.connection.namespace,
      parser: (state) => state.connection.parser,
      sessionId: (state) => state.connection.sessionId,
      currentToken: (state) => state.user.token
    }),
    ...mapGetters("transcription", ["transcribing"]),
    ...mapGetters("video", ["videoRoomWidgetBootstraped"]),
  },
  methods: {
    pingServer() {
      this.socket.emit("pingServer", "PING!");
    },
    playSound(eventType) {
      let clip = null;
      switch (eventType) {
        case "participant-joined": {
          clip = "/assets/audio/doorbell-1.ogg";
          break;
        }
        case "participant-left": {
          clip = "/assets/audio/door-9-close.ogg";
          break;
        }
      }
      if (clip) {
        var audio = new Audio(clip);
        audio.play();
      }
    },
    registerEventListeners(socket) {
      socket.on("updateVideoStatus", (data) => {
        if (data && data.status !== null) {
          /* eslint-disable */
          console.log("[IO:updateVideoStatus] " + JSON.stringify(data));

          this.$store.commit("video/upsertVideoRoom", data);

          if (data.callback_event == "participant-connected") {
            this.$store.commit("video/addParticipant", { roomId: data.room_id, participantId: data.participant_sid, participantName: data.participant_identity });
            this.playSound("participant-joined");
          }
          else if (data.callback_event == "participant-disconnected") {
            this.$store.commit("video/removeParticipant", { roomId: data.room_id, participantId: data.participant_sid });
            this.playSound("participant-left");
          }
        }
      });
    }
  },
  async created() {
    const socket = io(process.env.VUE_APP_SOCKET_URI + this.namespace, {
      forceNew: true,
      reconnection: false,
      withCredentials: ["sandbox", "production", "qa"].includes(process.env.NODE_ENV), // false for dev, true everywhere else - needed for cookie-based sticky-sessions
      transports: this.wsOnly ? ["websocket"] : ["websocket", "polling"],
      path: this.path,
      parser: this.parser === "msgpack" ? msgpackParser : null,
      auth: { token: `Bearer ${this.accessToken}` }
    });

    socket.once("connect", () => {
      socket.io.reconnection(true);
      SocketHolder.socket = socket;
      this.registerEventListeners(socket);
    });

    socket.on("connect", (socketId = socket.id, ts = new Date().toISOString()) => {
      this.$store.commit("connection/connect", { socketId, ts });
      socket.emit("joinConversation", this.conversationId);
    });

    socket.on("connect_error", (err) => {
    });

    socket.on("disconnect", (reason) => {
      this.$store.commit("connection/disconnect");
    });

    socket.on("enableCamera", (data) => {
      const { identity } = data;
      EventBus.$emit("video.enable-camera", identity);
    });

    socket.on("disableCamera", (data) => {
      const { identity } = data;
      EventBus.$emit("video.disable-camera", identity);
    });

    socket.on("enableAudio", (data) => {
      const { identity } = data;
      EventBus.$emit("video.enable-audio", identity);
    });

    socket.on("disableAudio", (data) => {
      const { identity } = data;
      EventBus.$emit("video.disable-audio", identity);
    });

    socket.on("toggleCamera", (data) => {
      EventBus.$emit("video.toggle-camera", data);
    });

    socket.on("shareLocation", (data) => {
      EventBus.$emit("video.share-location", data);
    });

    socket.on("receive-share-information", (data) => {
      console.log("[IO:receive-share-information]", data);
      if (data.type == 'recognition-language') {
        this.$store.commit("transcription/setRecognitionLanguages", data.data);
      }
    });

    socket.on("changeRecognitionLanguage", (data) => {
      EventBus.$emit("change-recognition-language", data);
    });

    socket.on("callerNewMessage", (data) => {
      const { direction, conversationId, message, source } = data;
      if (direction === 'outbound') {
        EventBus.$emit("chat.receive-message", conversationId);
        EventBus.$emit("chat.new-msg-badge");

        if (source !== 'transcribe') {
          this.$toastr("success", "New Message!");
          const audio = new Audio("/assets/audio/juntos-607.ogg");
          audio.play();
        }
      }
    });

    socket.on("video:receive-transcription", (data) => {
      if (this.videoRoomWidgetBootstraped) {
        if (!this.transcribing) {
          EventBus.$emit("start-transcription")
        } else {
          EventBus.$emit("video:receive-transcription", data);
        }
      }
    });

    socket.on("sdk:receive-transcription", (data) => {
      if (this.videoRoomWidgetBootstraped) {
        const { status, conversationId, identity, languages, transcription, translations, recipientId, resultJsonId } = data;
        if (!this.transcribing) {
          EventBus.$emit("start-transcription")
        } else {
          EventBus.$emit("sdk:receive-transcription", { status, conversationId, identity, languages, transcription, translations, recipientId, resultJsonId });
        }
      }
    })

    socket.on("start-transcription", (data) => {
      EventBus.$emit("start-transcription", data)
    });

    socket.on("stop-transcription", (data) => {
      EventBus.$emit("stop-transcription", data)
    });

    EventBus.$on("sdk:send-transcription", (data) => {
      socket.emit("sdk:send-transcription", data);
    })

    EventBus.$on("video:send-transcription", (data) => {
      socket.emit("video:send-transcription", data);
    })

    EventBus.$on("video.join-room", (roomId) => {
      socket.emit("joinVideo", roomId);
    });

    EventBus.$on("video.leave-room", (data) => {
      socket.emit("leaveVideo", data.roomId);
    });

    EventBus.$on("chat.send-message", (data) => {
      socket.emit("send-message", { direction: 'inbound', ...data });
    });

    EventBus.$on("share-information", (data) => {
      socket.emit("share-information", data)
    });

    EventBus.$on("shareVisibilityInformation", (data) => {
      socket.emit("remoteControl", data);
    });
    
    const voiceDialectsResponse = await this.$ConveyApi.translationApi.getSupportedLanguages({
      params: {
        voice: true,
        text: false
      }
    });
    const textDialectsResponse = await this.$ConveyApi.translationApi.getSupportedLanguages({
      params: {
        voice: false,
        text: true
      }
    });
    this.$store.commit("transcription/setDialects", {
      voiceDialects: voiceDialectsResponse.data.data,
      textDialects: textDialectsResponse.data.data,
    });
  },
  beforeDestroy() {
    EventBus.$off("video.join-room");
    EventBus.$off("video.leave-room");
    EventBus.$off("chat.send-message");
    EventBus.$off("video:send-transcription");
    EventBus.$off("share-information");
    if (SocketHolder.socket) {
      SocketHolder.socket.disconnect();
      SocketHolder.socket.off("connect");
      SocketHolder.socket.off("connect_error");
      SocketHolder.socket.off("disconnect");
    }
  },
};
</script>
